import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { zones } from 'services/zones';
import { GridContainer } from 'libs/ui';
import { Filter } from './parkings-filter';

export const Parkings = () => {
  const { t } = useTranslation();
  const items = zones.getZones();
  if (!items || !items.length) {
    return null;
  }

  const initialValues = {
    end_at: moment(),
    zones: items.map((el) => el.zone_id),
  };

  return (
    <GridContainer>
      <Filter initialValues={initialValues} t={t} />
    </GridContainer>
  );
};
